import axios from '../config/axios';
const DIAGRAM_API = '/projects/diagram';
const PROTOCOL_XML_API = '/projects/protocol-xml';


export const saveTrialSchemaDiagram = (projectId, xml) =>
  //axios.post(API, { projectId, xml });
  axios.post(DIAGRAM_API, { projectId, xml });


export const getTrialSchemaDiagram = (projectId) =>
 // axios.get(`${API}/${projectId}`); 
 axios.get(`${DIAGRAM_API}/${projectId}`);

export const saveProtocolXml = (projectId, xml) =>
  axios.post(PROTOCOL_XML_API, { projectId, xml });

export const getProtocolXml = (projectId) =>
  axios.get(`${PROTOCOL_XML_API}/${projectId}`);